import axios from 'axios';
import { API_BASE_URL } from '../const/constants';

// 인증 헤더 없이 공개 엔드포인트만 호출하는 클라이언트
// 공유 간트차트 조회 등 로그인 없이 접근 가능한 API에 사용
const publicApiClient = axios.create({
    baseURL: API_BASE_URL,
    timeout: 30000,
    headers: { 'Content-Type': 'application/json' },
});

export const publicApi = {
    get: async (endpoint) => {
        try {
            const response = await publicApiClient.get(endpoint);
            return { ok: true, status: response.status, data: response.data };
        } catch (error) {
            if (error.response) {
                return { ok: false, status: error.response.status, data: error.response.data };
            }
            return { ok: false, status: 0, data: null };
        }
    },
    post: async (endpoint, body) => {
        try {
            const response = await publicApiClient.post(endpoint, body);
            return { ok: true, status: response.status, data: response.data };
        } catch (error) {
            if (error.response) {
                return { ok: false, status: error.response.status, data: error.response.data };
            }
            return { ok: false, status: 0, data: null };
        }
    },
};